module.exports = __webpack_public_path__ + "static/media/growth-analytics.2e421def.svg";